<tr [ngClass]="cssClassName">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="item.bundle.length > 0 ? 'set' : 'empty'" i18n>
    Bundle
  </td>
  <td>
    <span *ngIf="item.bundle.length === 0" class="text-muted">
      <ng-container *ngIf="!item.bundleIsEditable()" i18n>Not available </ng-container>
      <ng-container *ngIf="item.bundleIsEditable()" i18n>Not set </ng-container>
    </span>
    <eas-editor-booking-item-bundle-summary *ngIf="item.bundle.length > 0" [bundle]="item.bundle">
    </eas-editor-booking-item-bundle-summary>
    <button *ngIf="item.bundleIsEditable()"
      mat-icon-button
      aria-label="Edit bundle"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    <eas-editor-booking-item-inheritable-type-badge *ngIf="item.bundle.length > 0"
      [inheritableType]="'set'">
    </eas-editor-booking-item-inheritable-type-badge>
  </td>
</tr>
